import { clsx } from 'clsx';

import CheckboxTreeNode from './components/CheckboxTreeNode/CheckboxTreeNode';

import type ICheckboxTree from './interfaces/ICheckboxTree';
import type ICheckboxTreeItem from './interfaces/ICheckboxTreeItem';

import styles from './scss/CheckboxTree.module.scss';

function CheckboxTree({
  items, selectedLeafIds, onChangeSelectedLeafIds, className,
}: ICheckboxTree) {
  const collectLeafIds = (treeItem: ICheckboxTreeItem): string[] => (
    treeItem.children.length > 0
      ? treeItem.children.flatMap((child) => collectLeafIds(child))
      : [treeItem.id]
  );

  const handleToggleItem = (item: ICheckboxTreeItem) => {
    const leafIds = collectLeafIds(item);
    const isAnySelected = leafIds.some((leafId) => selectedLeafIds.includes(leafId));

    if (isAnySelected) {
      onChangeSelectedLeafIds(selectedLeafIds.filter((selectedLeafId) => !leafIds.includes(selectedLeafId)));
      return;
    }

    onChangeSelectedLeafIds(Array.from(new Set([...selectedLeafIds, ...leafIds])));
  };

  return (
    <div className={clsx(styles.root, className)}>
      {items.map((item) => (
        <CheckboxTreeNode
          key={item.id}
          item={item}
          selectedLeafIds={selectedLeafIds}
          onToggleItem={handleToggleItem}
        />
      ))}
    </div>
  );
}

export default CheckboxTree;
